import { createSlice } from '@reduxjs/toolkit';
export default createSlice({
    name: 'product',
    initialState: {
        current: null,
    },
    reducers: {
        updateCurrent: (state, action) => {
            state.current = action.payload;
        },
    },
});
